const MONTHS_BY_NUMBER: Record<string, string> = {
  '01': 'Jan',
  '02': 'Fev',
  '03': 'Mar',
  '04': 'Abr',
  '05': 'Mai',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Ago',
  '09': 'Set',
  '10': 'Out',
  '11': 'Nov',
  '12': 'Dez',
};

const MONTHS_BY_TEXT: Record<string, string> = {
  jan: 'Jan',
  fev: 'Fev',
  mar: 'Mar',
  abr: 'Abr',
  mai: 'Mai',
  jun: 'Jun',
  jul: 'Jul',
  ago: 'Ago',
  set: 'Set',
  out: 'Out',
  nov: 'Nov',
  dez: 'Dez',
};

const normalizeYear = (value: string) => (value.length === 2 ? `20${value}` : value);

export default function formatNegotiationDeadlineLabel(value?: string | null) {
  const label = String(value || '').trim();

  if (!label) {
    return undefined;
  }

  const match = label.match(/^([A-Za-zÀ-ÿ]{3}|\d{2})\s*\/\s*(\d{2}|\d{4})$/);

  if (!match) {
    return label;
  }

  const monthToken = match[1];
  const yearToken = match[2];
  const month =
    MONTHS_BY_NUMBER[monthToken] ||
    MONTHS_BY_TEXT[
      monthToken
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    ];

  if (!month) {
    return label;
  }

  return `${month}/${normalizeYear(yearToken)}`;
}
